import { toNameConfigMapping } from '../../../configFields';
import { MobileStoriesWelcome } from './MobileStoriesWelcome';
import { Welcome } from './Welcome';

export const Welcomes = {
  Welcome,
  MobileStoriesWelcome,
};

export const welcomesList = [Welcome, MobileStoriesWelcome] as const;

export const welcomesMapping = toNameConfigMapping(welcomesList);
